import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom";
import {getAuthToken, removeAuthToken} from "../helpers/AuthTokenHelper";
import axios from "axios";
import {route, useRoute} from "ziggy-js";
import LoadingPane from "../components/LoadingPane";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import {DisabledProvider, ToastProvider} from "toolbox-react-frontend-components";
import AdminLayout from "./components/AdminLayout/AdminLayout";
import EditPage from "./pages/Page/EditPage";
import {redirectToLogin} from "../helpers/AuthHelper";
import IndexAlbum from "./pages/Album/IndexAlbum";
import CreateEditAlbum from "./pages/Album/CreateEditAlbum";
import IndexSetting from "./pages/Setting/IndexSetting";

const AdminApp = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (loading) {
            setupApplication();
        }
    }, [loading]);

    const setupApplication = () => {
        const token = getAuthToken();

        /*
         * Check if token is set, if not redirect to login.
         */
        if (!token) {
            redirectToLogin();
            return;
        }

        setupAxios(token);

        /*
         * Test axios setup to make sure token is valid
         */
        axios.get(route('api.admin.valid-token'))
            .then((response) => {
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);

                removeAuthToken();
                redirectToLogin();
            });
    }

    const setupAxios = (token) => {
        /*
         * Setup axios so that all calls will include the token
         */
        axios.defaults.headers.common['Authorization'] = 'Bearer '+token;

        /*
         * Setup axios so that all calls are intercepted to
         * log the system out if unauthenticated.
         */
        axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            /*
             * Check if the response is unauthenticated.
             */
            if (!!error && !!error.response && !!error.response.status && error.response.status === 401) {
                // Log out the platform.
                removeAuthToken();

                redirectToLogin();
                return;
            }

            /*
             * Standard error response to be handled.
             */
            return Promise.reject(error);
        });
    }

    const router = createBrowserRouter([
        {
            path: "/",
            element: (
                <AdminLayout />
            ),
            // errorElement: <ErrorPage/>,
            children: [
                {
                    path: route('admin.dashboard', undefined, false),
                    element: (
                        <DashboardPage />
                    ),
                }, {
                    path: route('admin.profile.edit', undefined, false),
                    element: (
                        <ProfilePage />
                    ),
                }, {
                    path: route('admin.page.edit', {page: ':page'}, false),
                    element: (
                        <EditPage />
                    ),
                }, {
                    path: route('admin.album.index', undefined, false),
                    element: (
                        <IndexAlbum />
                    ),
                }, {
                    path: route('admin.setting.index', undefined, false),
                    element: (
                        <IndexSetting />
                    ),
                }, {
                    path: route('admin.album.create', undefined, false),
                    element: (
                        <CreateEditAlbum mode={'CREATE'} />
                    ),
                }, {
                    path: route('admin.album.edit', {album: ':album'}, false),
                    element: (
                        <CreateEditAlbum mode={'EDIT'} />
                    ),
                },
            ]
        }
    ]);

    if (loading) {
        return (
            <LoadingPane />
        )
    }

    return (
        <DisabledProvider>
            <ToastProvider position={'top-right'}>
                <RouterProvider router={router} />
            </ToastProvider>
        </DisabledProvider>
    );
}

export default AdminApp;

const app = document.getElementById('admin-authed-app');
if (app) {
    ReactDOM.render(<AdminApp />, app);
}
